// React Imports
import { useEffect } from "react";

// Redux Imports
import { useDispatch, useSelector } from "react-redux";
import {
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalData,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";

// Utils Imports
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";

// Component Imports
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithCTA from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import CommonToast from "../../_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const FieldForceRequestTxnMultiCard = ({
  filterOpen,
  data,
  setAllAccounts,
  setselectAllCard,
  selectedTransactions,
  setSelectedTransactions,
  setTotalAmount,
  setSelectedSendTransactions,
  selectedSendTransactions,
  SideDrawerOpen,
  openBeneTxnDetailModal,
  setTxnId,
  setDatas,
  filterRef,
}) => {
  // 1️⃣ useDispatch
  const dispatch = useDispatch();

  // 2️⃣ useSelector
  const { BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError } =
    useSelector((state) => state?.beneTxnViewAccData);

  // 3️⃣ Callback / Handler functions
  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const handleCardClick = (account) => {
    if (account?.field_force_account_approval_status === "approved") {
      setselectAllCard(false);
      setSelectedTransactions((prevSelected) => {
        const cardAmount = Number(account?.requested_amount);
        const isSelected = prevSelected.includes(account?.request_id);

        if (isSelected) {
          setTotalAmount((prevAmount) => prevAmount - cardAmount);
          const newData = selectedSendTransactions.filter(
            (val) => val?.request_id !== account?.request_id,
          );
          setSelectedSendTransactions(newData);
          return prevSelected.filter((id) => id !== account?.request_id);
        }
        if (prevSelected.length < GlobalConfiguration.categorymaxLength) {
          setTotalAmount((prevAmount) => prevAmount + cardAmount);
          setSelectedSendTransactions((prev) => [...prev, account]);
          return [...prevSelected, account?.request_id];
        }
        return prevSelected;
      });
    }
  };

  const handleCtaClick = (e, account) => {
    e.stopPropagation();
    setDatas(account);

    if (!sessionStorage.getItem("q2p_token")) {
      return;
    }
    if (
      account?.field_force_account_approval_status === "pending" ||
      account?.field_force_account_approval_status === "rejected"
    ) {
      SideDrawerOpen(account?.field_force_account_id);

      // CommonToast({
      //   text: "Feature coming soon",
      //   icon: ICONS?.INFO,
      //   variant: "var(--coming-soon)",
      //   buttonNeeded: false,
      // });
    } else {
      openBeneTxnDetailModal();
      setTxnId(account?.request_id);
      // CommonToast({
      //   text: "Feature coming soon",
      //   icon: ICONS?.INFO,
      //   variant: "var(--coming-soon)",
      //   buttonNeeded: false,
      // });
    }
  };

  // 4️⃣ useEffect
  useEffect(() => {
    dispatch(resetBeneTxnMultiApprovalError());
    dispatch(resetBeneTxnMultiDeniedApprovalData());
  }, [BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError, dispatch]);

  console.log(data);
  return (
    <>
      <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
        {data?.map((account) => (
          <CardContainer
            hoverHeight={
              GlobalConfiguration?.reimbursementTxnMultiApprovalCardHoverHeight
            }
            filterRef={filterRef}
            isDisabled={
              filterOpen ||
              account?.field_force_account_approval_status === "pending" ||
              account?.field_force_account_approval_status === "rejected"
            }
            key={account?.request_id}
            isSelected={selectedTransactions.includes(account?.request_id)}
            onClickHandler={() => handleCardClick(account)}
            varaint="overlay"
          >
            <card-body>
              <TextWithIcon
                type={
                  account?.field_force_account_approval_status === "pending" ||
                  account?.field_force_account_approval_status === "rejected"
                    ? "Text"
                    : "Amount"
                }
                fontWeight={"semibold"}
                text={
                  account?.field_force_account_approval_status === "pending"
                    ? "Account approval pending"
                    : account?.field_force_account_approval_status ===
                        "rejected"
                      ? "Account approval rejected"
                      : account?.requested_amount
                }
                textColor={getStatusColor(
                  account?.field_force_account_approval_status,
                )}
                subText={
                  account?.field_force_account_approval_status === "pending" ||
                  account?.field_force_account_approval_status === "rejected"
                    ? "Account status"
                    : "Amount"
                }
                iconComponentArray={
                  account?.field_force_account_approval_status === "approved"
                    ? [
                        ...(account?.confidential_transaction === "Y"
                          ? [
                              {
                                icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                title: "confidential",
                                isDisabled: false,
                              },
                            ]
                          : []),
                        {
                          icon: selectedTransactions.includes(
                            account?.request_id,
                          )
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE,
                          isDisabled: false,
                        },
                      ]
                    : []
                }
              />
              <TextWithIcon
                type={"Text"}
                fontWeight={"var(--font-normal)"}
                text={account?.field_force_account_name}
                textColor={"var(--text-primary)"}
                subText="Account name"
              />

              <TextWithCTA
                btnText={
                  account?.field_force_account_approval_status === "pending" ||
                  account?.field_force_account_approval_status === "rejected"
                    ? "Approve account"
                    : "Field force details"
                }
                enabledBgColor={"var(--text-primary)"}
                enabledTextColor={"var(--primary-bg)"}
                handleFunction={(e) => handleCtaClick(e, account)}
                icon={ICONS?.ARROW_RIGHT_WHITE}
                isDisabled={!!filterOpen}
                text={
                  account?.created_on
                    ? formatDateViewAll(account?.created_on, false, false)
                    : "Not given"
                }
                subText="Date"
                type={"Text"}
              />
            </card-body>
          </CardContainer>
        ))}
      </div>
    </>
  );
};
export default FieldForceRequestTxnMultiCard;
